import { render, staticRenderFns } from "./ManagedExpenseColumnSortIcon.vue?vue&type=template&id=09f19dca&scoped=true"
import script from "./ManagedExpenseColumnSortIcon.vue?vue&type=script&lang=ts"
export * from "./ManagedExpenseColumnSortIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f19dca",
  null
  
)

export default component.exports